import styled from 'styled-components'

export const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  background: #f4f4f4;
  border: 1px solid #d9d9d9;
  border-bottom: none;
  flex-wrap: wrap;
`

export const Spacer = styled.div`
  flex: 1 1 auto;
`

export const Group = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const Divider = styled.span`
  width: 1px;
  height: 18px;
  background: #d9d9d9;
  margin: 0 2px;
`
